export const viewPoints = {
  front: [
    {
      id: 1,
      name: '오른쪽 범퍼(앞)',
      x: 65,
      y: 30,
      dotPosition: {
        spacing: 10,
        top: 15,
        side: -10
      },
      mobilePosition: {
        spacing: 8,
        top: 15,
        side: -8
      }
    },
    {
      id: 2,
      name: '프론트 판넬',
      x: 50,
      y: 95,
      dotPosition: {
        spacing: 10,
        top: 13,
        side: -10
      },
      mobilePosition: {
        spacing: 8,
        top: 14,
        side: -8
      }
    },
    {
      id: 3,
      name: '본네트',
      x: 120,
      y: 128,
      dotPosition: {
        spacing: 10,
        top: 12,
        side: -10
      },
      mobilePosition: {
        spacing: 8,
        top: 14,
        side: -8
      }
    },
    {
      id: 4,
      name: '왼쪽 범퍼(앞)',
      x: 65,
      y: 160,
      dotPosition: {
        spacing: 10,
        top: 23,
        side: -10
      },
      mobilePosition: {
        spacing: 8,
        top: 14,
        side: -8
      }
    }
  ],
  back: [
    {
      id: 1,
      name: '트렁크',
      x: 385,
      y: 85,
      dotPosition: {
        spacing: 10,
        top: 11,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 15,
        side: 8
      }
    },
    {
      id: 2,
      name: '리어판넬',
      x: 380,
      y: 130,
      dotPosition: {
        spacing: 20,
        top: 11,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 10,
        side: 8
      }
    },
    {
      id: 3,
      name: '오른쪽 범퍼(뒤)',
      x: 320,
      y: 35,
      dotPosition: {
        spacing: 30,
        top: 10,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 10,
        side: 8
      }
    },
    {
      id: 4,
      name: '왼쪽 범퍼(뒤)',
      x: 340,
      y: 170,
      dotPosition: {
        spacing: 25,
        top: 10,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 5,
        side: 8
      }
    }
  ],
  top: [
    {
      id: 1,
      name: '루프판넬',
      x: 265,
      y: 80,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 44,
        side: 8
      }
    }
  ],
  driver: [
    {
      id: 1,
      name: '앞펜더(좌)',
      x: 80,
      y: 75,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 2,
      name: '앞휠하우스(좌)',
      x: 80,
      y: 150,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    },
    {
      id: 3,
      name: 'A필러(좌)',
      x: 160,
      y: 45,
      dotPosition: {
        spacing: 10,
        top: 45,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 4,
      name: '앞문(좌)',
      x: 170,
      y: 140,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    },
    {
      id: 5,
      name: 'B필러(좌)',
      x: 260,
      y: 35,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 6,
      name: '뒷문(좌)',
      x: 265,
      y: 140,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    },
    {
      id: 7,
      name: '뒤펜더(좌)',
      x: 380,
      y: 30,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 8,
      name: '뒤휠하우스(좌)',
      x: 385,
      y: 150,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    }
  ],
  passenger: [
    {
      id: 1,
      name: '앞펜더(우)',
      x: 380,
      y: 80,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 2,
      name: '앞휠하우스(우)',
      x: 395,
      y: 160,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    },
    {
      id: 3,
      name: 'A필러(우)',
      x: 310,
      y: 45,
      dotPosition: {
        spacing: 10,
        top: 35,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 4,
      name: '앞문(우)',
      x: 265,
      y: 140,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    },
    {
      id: 5,
      name: 'B필러(우)',
      x: 215,
      y: 45,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 6,
      name: '뒷문(우)',
      x: 170,
      y: 140,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    },
    {
      id: 7,
      name: '뒤펜더(우)',
      x: 80,
      y: 75,
      dotPosition: {
        spacing: 10,
        top: 32,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: 40,
        side: 8
      }
    },
    {
      id: 8,
      name: '뒤휠하우스(우)',
      x: 80,
      y: 150,
      dotPosition: {
        spacing: 10,
        top: -8,
        side: 10
      },
      mobilePosition: {
        spacing: 8,
        top: -6,
        side: 8
      }
    }
  ]
};